<template>
  <el-dialog custom-class="medium-dialog" title="商品唯一码" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-input v-model="goodsbarcode" @change="search" @clear="search" clearable
                  style="width: 200px" placeholder="请输入唯一码"></el-input>
      </el-col>
      <el-table
        :data="tableData"
        :height="tableHeight(100)"
        size="mini"
        border
        style="width: 100%;">
        <el-table-column label="仓库" fixed align="left" header-align="center" prop="cangkuname" v-if="false">
        </el-table-column>
        <el-table-column label="名称" fixed align="left" header-align="center" prop="seedname">
        </el-table-column>
        <el-table-column label="编码" align="left" header-align="center" width="140" prop="seedcode">
        </el-table-column>
        <el-table-column label="唯一码" align="left" header-align="center" width="200" prop="goodsbarcode">
        </el-table-column>

      </el-table>
    </div>
  </el-dialog>
</template>

<script>
  import {listData} from '@/api/set/jxcstoregoodsbarcode';


  export default {
    name: "UniqueCode",
    data() {
      return {
        tableData: [],
        seedcode: '',
        seedname: '',
        cangkucode: '',
        cangkuname: '',
        dialogFormVisible: false,
        goodsbarcode: '',
      }
    },
    methods: {
      show() {
        this.dialogFormVisible = true
        this.init();
      },
      search() {
        listData({
          erps: 32,
          seedcode: this.seedcode,
          cangkucode: this.cangkucode,
          goodsbarcode: this.goodsbarcode
        }).then(response => {
          this.tableData = response.data.obj
        })
      },
      initData(cangkucode, cangkuname, seedcode, seedname) {
        this.seedcode = seedcode
        this.cangkucode = cangkucode
        this.cangkuname = cangkuname
        this.seedname = seedname
        this.search()
      },
      init() {
        this.goodsbarcode = ''
        this.seedcode = ''
        this.cangkucode = ''
        this.cangkuname = ''
        this.seedname = ''
        this.tableData = []
      },
    },
    mounted() {
    },
    components: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/warehouse/UniqueCode.vue